// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2692":"6790d729","3157":"6790d729"}[chunkId] + ".chunk.css";
};